export const SHOW_VIDEO_UPLOAD_MODAL = 'show-video-upload-modal';

export const showVideoUploadModal = showVideoUploadModal => {
  return {
    type: SHOW_VIDEO_UPLOAD_MODAL,
    showVideoUploadModal,
  };
};
